import {
  Backdrop,
  Button,
  Fade,
  FormControl,
  IconButton,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import { commonGreData } from "data/greData/commonGreData";
import { deleteFromStorage, saveToStorage } from "utils/storage";
import { commonData } from "data/CommonDataPoint";
import { FetchData } from "hooks/api/useApiService";
import { createEndpoint } from "config/apiEndpoints";
import Grid from "@mui/material/Grid";

const RoleChangeModal = () => {
  // const [selectValue, setSelectValue] = useState(null);
  const setUserType = getUserType((state) => state.setUserType);
  const isUserType = getUserType((state) => state.isUserType);
  const userData = getUserType((state) => state.userData);
  // const projectListData = generalStore((state) => state.projectListData);
  // const setProjectListData = generalStore((state) => state.setProjectListData);

  const setRoleModalOpen = generalStore((state) => state.setRoleModalOpen);
  const roleModalOpen = generalStore((state) => state.roleModalOpen);
  // const setSelectedProject = generalStore((state) => state.setSelectedProject);
  // const selectedProject = generalStore((state) => state.selectedProject);
  // const setSelectedRole = generalStore((state) => state.setSelectedRole);
  // const selectedRole = generalStore((state) => state.selectedRole);
  const [selectedRole, setSelectedRole] = useState(null);

  const history = useHistory();

  const goToOtherPage = (route) => {
    history.push(route);
  };

  // const handleSelectChange = (e) => {
  //   setSelectValue(e.target.value);
  //   setSelectedProject(e.target.value);
  // };

  const handleSelectRole = (e) => {
    // saveToStorage(
    //   "user_token",
    //   userData?.roles?.find((ele) => ele?.user_role == e.target.value)
    //     ?.access_token
    // );
    // setUserType(e.target.value);
    setSelectedRole(e.target.value);
  };

  // useEffect(() => {
  //   if (userData?.roles?.length == 1) {
  //     setSelectedRole(userData?.roles?.[0]?.user_role);
  //   }
  // }, [userData]);

  // const projectListingAction = {
  //   select: (data) => {
  //     const list = data.data;
  //     return list;
  //   },
  //   onSuccess: (data) => {
  //     if (data?.statusCode == 200) {
  //       setProjectListData(data?.data);
  //       if (selectedProject == null && commonData?.admin == isUserType) {
  //         setSelectedProject(data?.data[0]?.projectId);
  //       }
  //     }
  //   },
  //   retry: false,
  //   enabled: selectedRole ? true : false,
  // };
  // const { refetch } = FetchData(
  //   "userProjectList",
  //   createEndpoint("userProjectList"),
  //   projectListingAction
  // );

  const user_data = JSON.parse(sessionStorage.getItem("user_data"));

  const handleProjectModalSubmit = () => {
    setRoleModalOpen(false);
    if (selectedRole) {
      const getSelectedRoleData = user_data?.roles?.find(
        (ele) => ele?.user_role == selectedRole
      );
      if (user_data) {
        user_data.user_role = selectedRole; // ✅ update role
        user_data.access_token = getSelectedRoleData?.access_token; // ✅ update access token
        user_data.refresh_token = getSelectedRoleData?.refresh_token; // ✅ update refresh token
      }

      // Save it back to sessionStorage
      // sessionStorage.setItem("user_data", JSON.stringify(user_data));
      if (selectedRole == commonData?.greRole) {
        history.push(`/${selectedRole}/customer-search`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (
        selectedRole?.replace(/\s/g, "") == commonData?.closingTeamLeadRole
      ) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/assign-customer`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.salesRole) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (
        selectedRole?.replace(/\s/g, "") == commonData?.sourcingTeamLeadRole
      ) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (
        selectedRole?.replace(/\s/g, "") == commonData?.sourcingManagerRole
      ) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/booking`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.regionalHead) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.projectHead) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.verticalHead) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (
        selectedRole?.replace(/\s/g, "") == commonData?.subVerticalHead
      ) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.CRM) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/dashboard`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      } else if (selectedRole?.replace(/\s/g, "") == commonData?.admin) {
        history.push(`/${selectedRole?.replace(/\s/g, "")}/project-listing`);
        sessionStorage.setItem("user_data", JSON.stringify(user_data));
      }
      // Refresh the page to apply changes
      window.location.reload();
    }

    // const getSelectedRoleData = userData?.roles?.find(
    //   (ele) => ele?.user_role == selectedRole
    // );
    // const modifyRoleWisedData = {
    //   ...userData,
    //   ...getSelectedRoleData,
    // };
  };

  const handleClose = () => {
    setRoleModalOpen(false);
    setSelectedRole(null);
    // deleteFromStorage("user_token");
    // setProjectListData([]);
    // setSelectedProject(null);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={roleModalOpen}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bs-modal typ-scan"
      >
        <Fade in={roleModalOpen}>
          <div className="modal-cont">
            <div className="modal-header">
              <h3 className="title">Select Role</h3>
              <IconButton
                className="bs-btn btn-icon"
                disableRipple
                onClick={handleClose}
              >
                <span className="icon icon-close"></span>
              </IconButton>
            </div>
            <div className="modal-body">
              <div className="bs-form">
                <Grid
                  container
                  rowSpacing={{ md: 2.5, xs: 2.5 }}
                  columnSpacing={{ md: 2.5, xs: 2.5 }}
                >
                  <Grid item xs={12} sm={12}>
                    {userData?.roles?.length > 1 && (
                      <div className="form-group">
                        <div className="input-label">
                          <p className="label">Select Role</p>
                        </div>
                        <div className="bs-select">
                          <FormControl className="form-control">
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={selectedRole}
                              onChange={handleSelectRole}
                              placeholder="Select"
                              IconComponent={(props) => (
                                <span
                                  {...props}
                                  className={`cmp-select__icon icon-chevron-down ${props.className}`}
                                ></span>
                              )}
                              MenuProps={{
                                classes: {
                                  paper: "bs-select-menu",
                                },
                              }}
                              displayEmpty
                            >
                              <MenuItem value={null} disabled selected>
                                Select
                              </MenuItem>
                              {userData?.roles?.map((role, index) => {
                                return (
                                  <MenuItem key={index} value={role?.user_role}>
                                    {role?.user_role}
                                  </MenuItem>
                                );
                              })}
                              {/* <MenuItem value={1}>Mahindra Vista</MenuItem>
                        <MenuItem value={2}>Mahindra Alcove</MenuItem>
                        <MenuItem value={3}>Mahindra Alcove 2</MenuItem> */}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div className="form-action">
                      <div className="action-btn-wrap">
                        <Button
                          variant="contained"
                          className="bs-btn"
                          onClick={handleProjectModalSubmit}
                          disabled={selectedRole ? false : true}
                        >
                          <span className="text">Submit</span>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default React.memo(RoleChangeModal);
